import { Point } from 'src/app/math/point'
import { vector, Vector, add, asPoint } from 'src/app/math/vector'
import { gt } from 'src/app/math/util'

export class PointMotion {
  private readonly deltaT: number
  private readonly deltaX: number

  private readonly speed: number
  // private t = 0
  private a = 45
  // private speed = 0
  readonly p: Vector

  constructor(readonly source: Point, readonly destination: Point, speed0: number) {
    this.speed = speed0 * 1000
    this.p = vector(source, destination)
    this.deltaX = this.speed * this.speed / (2 * this.a)
    this.deltaT = this.speed / this.a
  }

  move(p: Point, elapsedMillis: number): Point {
    const elapsed = elapsedMillis / 1000 // work in seconds, not milliseconds
    const p0 = vector(this.source, p)
    const t0 = this.time(p0.length())
    const t = t0 + elapsed
    // this.t = this.t + elapsed
    // advance point for full amount of elapsed time
    const distance = 0.5 * (this.a * t * t) + this.speed * t
    const dx = this.p.normalize(distance)
    return add(this.source, dx)
  }

  // returns new point and remaining amount of time
  arrive(p: Point, elapsedMillis: number): [Point, number] {
    const elapsed = elapsedMillis / 1000 // work in seconds, not milliseconds
    const p0 = vector(this.source, p)
    const t1 = this.time(this.p.length())
    const t0 = this.time(p0.length())
    const totalTime = t1 - t0
    if (gt(totalTime, elapsed)) {
      const p1 = this.move(p, elapsedMillis)
      return [p1, 0]
    } else {
      // reached destination with time left over
      return [this.destination, elapsed-totalTime]
    }
  }

  protected time(x: number): number {
    const x0 = x + this.deltaX
    return -this.deltaT + Math.sqrt(2 * x0 / this.a)
  }
}
